import request from '../http/index.js'

export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data
  })
}
export function appLogin(data) {
  return request({
    url: '/jinRongPlus/auth',
    method: 'post',
    data
  })
}

export function getIndexStatistics(data) {
  return request({
    url: '/magorder/myOrderSummary',
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    url: '/getSysUserInfo',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}


export function getOrderDateLists(data) {
  return request({
    url: `/productitem/getPageList`,
    method: 'post',
    data
  })
}

export function getProductunitLists(data) {
  return request({
    url: `/productunit/getPageList `,
    method: 'post',
    data
  })
}

export function getArea(data) {
  return request({
    url: `/area/tree`,
    method: 'post',
    data
  })
}


export function getCommUnitLists(data) {
  return request({
    url: `/commonsub/getPageList`,
    method: 'post',
    data
  })
}
export function addCommUnit(data) {
  return request({
    url: `/commonsub/add`,
    method: 'post',
    data
  })
}

export function deleteCommUnit(id) {
  return request({
    url: `/commonsub/delete/${id}`,
    method: 'post'
  })
}

export function getCommUnitDetail(id) {
  return request({
    url: `/commonsub/info/${id}`,
    method: 'get'
  })
}

export function updateCommUnit(data) {
  return request({
    url: `/commonsub/update`,
    method: 'post',
    data
  })
}









export function getCommVoiceLists(data) {
  return request({
    url: `/commoninvoice/getPageList`,
    method: 'post',
    data
  })
}
export function addCommVoice(data) {
  return request({
    url: `/commoninvoice/add`,
    method: 'post',
    data
  })
}
export function getMyCommonInvoicePageList(data) {
  return request({
    url: `/commoninvoice/getMyCommonInvoicePageList`,
    method: 'post',
    data
  })
}

export function setInvoiceDefault(id) {
  return request({
    url: `/commoninvoice/setDefault/${id}`,
    method: 'post',
  })
}

// 删除发票单位信息
export function deleteInvoice(id) {
  return request({
    url: `/commoninvoice/delete/${id}`,
    method: 'post'
  })
}

// 上传凭证
export function uploadVoucherImg(data) {
  return request({
    url: `/magorder/uploadVoucherImg`,
    method: 'post',
    data
  })
}

export function hasUnPaidOrders() {
  return request({
    url: `/magorder/hasUnPaidOrders`,
    method: 'get',
  })
}

export function hasUnInvoiceOrders() {
  return request({
    url: `/magorder/hasUnInvoiceOrders`,
    method: 'get',
  })
}

export function getBannerList(data) {
  return request({
    url: `/banner/getPageList`,
    method: 'post',
    data
  })
}

export function getBannerInfo(id) {
  return request({
    url: `/banner/info/${id}`,
    method: 'get',
  })
}


export function deleteCommVoice(id) {
  return request({
    url: `/commoninvoice/delete/${id}`,
    method: 'post'
  })
}

export function getCommVoiceDetail(id) {
  return request({
    url: `/commoninvoice/info/${id}`,
    method: 'get'
  })
}

export function updateCommVoice(data) {
  return request({
    url: `/commoninvoice/update`,
    method: 'post',
    data
  })
}







export function getOrderLists(data) {
  return request({
    url: `/magorder/getPageList`,
    method: 'post',
    data
  })
}
export function addOrder(data) {
  return request({
    url: `/magorder/add`,
    method: 'post',
    data
  })
}
// 判断是否重复订单
export function checkOrderRepeat4Mobile(data) {
  return request({
    url: `/magorder/checkOrderRepeat4Mobile`,
    method: 'post',
    data
  })
}
export function deleteOrder(id) {
  return request({
    url: `/magorder/delete/${id}`,
    method: 'post'
  })
}

export function getOrderDetail(id) {
  return request({
    url: `/magorder/info/${id}`,
    method: 'get'
  })
}

export function updateOrder(data) {
  return request({
    url: `/magorder/update`,
    method: 'post',
    data
  })
}
// 修改订单
export function mobileUpdate(data) {
  return request({
    url: `/magorder/mobileUpdate`,
    method: 'post',
    data
  })
}

export function getMyOrders(data) {
  return request({
    url: `/magorder/getMyOrderPageList`,
    method: 'post',
    data
  })
}

export function getMyOrderPayDetail(id) {
  return request({
    url: `/payment/paymentInfo/${id}`,
    method: 'get'
  })
}

export function getLogoUrl() {
  return request({
    url: `/organize/getLogoUrl`,
    method: 'get'
  })
}

export function getPublishUnitLists(data) {
  return request({
    url: `/organize/getPageList`,
    method: 'post',
    data
  })
}
export function getMyOrderInvoiceDetail(id) {
  return request({
    url: `/invoice/getInvoiceByOrderId/${id}`,
    method: 'post'
  })
}

export function getChildOrder(orderId, data) {
  return request({
    url: `/magorder/getSubOrderList/${orderId}`,
    method: 'post',
    data
  })
}

export function addPayInfo(data) {
  return request({
    url: `/magorder/pay`,
    method: 'post',
    data
  })
}

export function saveVoucher(data) {
  return request({
    url: `/magorder/uploadVoucherImg`,
    method: 'post',
    data
  })
}




export function getKaiPiaoLists(data) {
  return request({
    url: `/invoice/getInvoiceByOrderId`,
    method: 'post',
    data
  })
}

export function getFukuanLists(data) {
  return request({
    url: `/payment/getPageList`,
    method: 'post',
    data
  })
}

export function getDefaultUnit() {
  return request({
    url: `/commonsub/getDefault`,
    method: 'post'
  })
}

export function setDefaultUnit(id, isdefault) {
  return request({
    url: `/commonsub/modifyDefault/${id}/${isdefault}`,
    method: 'post'
  })
}

export function getUserInfoDetail(id) {
  return request({
    url: `/sysUser/info/${id}`,
    method: 'get'
  })
}

export function updateUserInfo(data) {
  return request({
    url: `/sysUser/update`,
    method: 'post',
    data
  })
}

export function updateUserInfoPass(data) {
  return request({
    url: `/sysUser/updatePassword`,
    method: 'post',
    data
  })
}


export function getProductDetail(id) {
  return request({
    url: `/productitem/info/${id}`,
    method: 'get'
  })
}

export function getProductunitDetail(id) {
  return request({
    url: `/productunit//info/${id}`,
    method: 'get'
  })
}





export function getExpressLists(data) {
  return request({
    url: `/express/getPageList`,
    method: 'post',
    data
  })
}

export function setUnitDefault(id, isdefault) {
  return request({
    url: `/commonsub/modifyDefault/${id}/${isdefault}`,
    method: 'post',
  })
}


export function deleteUnit(id) {
  return request({
    url: `/commonsub/delete/${id}`,
    method: 'post',
  })
}

export function updateUnit(data) {
  return request({
    url: `/commonsub/update`,
    method: 'post',
    data
  })
}

export function addUnit(data) {
  return request({
    url: `/commonsub/add`,
    method: 'post',
    data
  })
}

export function uploadPic(data) {
  return request({
    url: `/upload`,
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}



export function addInvoice(data) {
  return request({
    url: `/invoice/add`,
    method: 'post',
    data
  })
}


export function getAppid(data) {
  return request({
    url: `/wxpay/wxCfgAppId`,
    method: 'get'
  })
}


export function getWXPayParams(payId, code) {
  return request({
    url: `/wxpay/createWithJsAPI/${payId}/${code}`,
    method: 'get'
  })
}


export function getAlipayParams(payId) {
  return request({
    url: `/alipay/createAlipayWithMobile/${payId}`,
    method: 'get'
  })
}





export function getGeoDivisionTree(data) {
  return request({
    url: `/area/tree`,
    method: 'post',
    data
  })
}

// 微信登录
export function auth(data) {
  return request({
    url: `/auth?code=${data.code}&state=${data.state}`,
    // url: `/auth`,
    method: 'post',
    // data: JSON.stringify(data)
  })
}

// 绑定手机验证码
export function smssend(phone) {
  return request({
    url: `/sms/send?phone=${phone}`,
    method: 'post',
  })
}
// 绑定手机
export function bindPhone(data) {
  return request({
    url: `/sysUser/bindPhone`,
    method: 'post',
    data
  })
}


export function getMailingList(data) {
  return request({
    url: `/mailing/getPageList`,
    method: 'post',
    data
  })
}

export function getSystemSetting(module) {
  return request({
    url: `/systemSettings/get/${module}`,
    method: 'get',
    params: { enabled: 1, module: 1 }
  })
}

export function getMyPageList(data) {
  return request({
    url: `/express/getMyPageList`,
    method: 'post',
    data
  })
}
// 获取支付方式列表
export function getPayTypeList() {
  return request({
    url: `/payType/getPayTypeList`,
    method: 'post',
    data: { pageIndex: 1, pageSize: 999, status: 0 }
  })
}

export function bindPhoneNotNow() {
  return request({
    url: `/sysUser/bindPhoneNotNow`,
    method: 'post'
  })
}

export function invoicing(data) {
  return request({
    url: `/magorder/invoicing`,
    method: 'post',
    data
  })
}

// 支付
export function pay(data) {
  return request({
    url: `/orderPay/pay`,
    method: 'post',
    data
  })
}

// 推送发票
export function invoicePush(data) {
  return request({
    url: `/invoice/push`,
    method: 'post',
    data
  })
}

// export function getGeoDivisionTree(data) {
//   return request({
//     url: `/area/tree`,
//     method: 'post',
//     data
//   })
// }
// 作废
export function magorderCancel(moId) {
  return request({
    url: `/magorder/invalid?moId=${moId}`,
    method: 'post',
  })
}



// WEBPACK FOOTER //
// ./src/util/api.js